module.exports = __webpack_public_path__ + "static/media/sc.38438ae6.png";